import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/main.css';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './Reducers/reducers'
import {
  loadNotes,
  saveNotes
} from './LocalStorage/localstorage'

const persistedState = loadNotes()
const logger = createLogger()

// const initState = {
//   fetching: false,
//   creating: false,
//   newlyAdded: false,
//   error: {
//     erroring: false,
//     errorMessage: 'No Error'
//   },
//   notes: []
// }

let store = createStore(rootReducer, persistedState, applyMiddleware(thunk, logger))

store.subscribe( () => {
  saveNotes(store.getState());
})

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

if (process.env.NODE_ENV !== 'development') {
  require('offline-plugin/runtime').install(); // eslint-disable-line global-require
}



// WEBPACK FOOTER //
// ./src/index.js